// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1DeB-","location":"Header_location__1SDIA"};